import { render, staticRenderFns } from "./ReportBoxTrendSales.vue?vue&type=template&id=170b6360&"
import script from "./ReportBoxTrendSales.vue?vue&type=script&lang=js&"
export * from "./ReportBoxTrendSales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('170b6360')) {
      api.createRecord('170b6360', component.options)
    } else {
      api.reload('170b6360', component.options)
    }
    module.hot.accept("./ReportBoxTrendSales.vue?vue&type=template&id=170b6360&", function () {
      api.rerender('170b6360', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/purchase-activity/reports/ReportBoxTrendSales.vue"
export default component.exports